<div class="kb">
  <ion-card>
    <ion-card-header>
      <ion-card-title>KIR-bejelentések</ion-card-title>
      <ion-card-subtitle>
        A jogviszony létesítését, a KIR-ben nyilvántartott adatok (évfolyam, egyéni munkarend, szünetelés) változását és a
        jogviszony megszűnését {{ hatarido_nap }} napon belül be kell jelenteni a KIR-en keresztül (229/2012. Korm. r. 14–17. §).
        A Sulinform a KIR-be nem küld adatot: a bejelentést a KIR felületén tedd meg, majd itt jelöld „Bejelentve”-nek.
        Az új és a lejáró tételekről naponta rendszerüzenet érkezik.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <ion-segment [(ngModel)]="szuro" scrollable="true">
        <ion-segment-button value="nyitott"><ion-label>Teendő ({{ szam('nyitott') }})</ion-label></ion-segment-button>
        <ion-segment-button value="lejart"><ion-label>Lejárt ({{ szam('lejart') }})</ion-label></ion-segment-button>
        <ion-segment-button value="bejelentve"><ion-label>Bejelentve ({{ szam('bejelentve') }})</ion-label></ion-segment-button>
        <ion-segment-button value="nem_kell"><ion-label>Nem kell ({{ szam('nem_kell') }})</ion-label></ion-segment-button>
        <ion-segment-button value="okafogyott"><ion-label>Forrás változott ({{ szam('okafogyott') }})</ion-label></ion-segment-button>
        <ion-segment-button value="kezdo"><ion-label>Kezdő állapot ({{ szam('kezdo') }})</ion-label></ion-segment-button>
        <ion-segment-button value="mind"><ion-label>Mind ({{ szam('mind') }})</ion-label></ion-segment-button>
      </ion-segment>

      <p class="halvany" *ngIf="szuro === 'kezdo'">
        A figyelő első futásakor talált, akkor már lejárt határidejű események (pl. a tanévkezdés évfolyamléptetései). Rájuk nem megy
        riasztás – nézd át, és jelöld tömegesen „Bejelentve” vagy „Nem kell” állapotúra.
      </p>
      <p class="halvany" *ngIf="szuro === 'okafogyott'">
        A jogviszony-adat az esemény rögzítése óta megváltozott vagy törlődött (pl. javított dátum). Ha a KIR-ben nincs vele teendő, jelöld „Nem kell”-nek.
      </p>

      <div class="kb-sor">
        <ion-searchbar [(ngModel)]="kereses" placeholder="Név vagy oktatási azonosító" [debounce]="200"></ion-searchbar>
        <ion-select [(ngModel)]="tipusSzuro" interface="popover" label="Kik" labelPlacement="stacked" fill="outline">
          <ion-select-option value="">Mindenki</ion-select-option>
          <ion-select-option value="tanulo">Tanulók</ion-select-option>
          <ion-select-option value="alkalmazott">Alkalmazottak</ion-select-option>
        </ion-select>
        <ion-button fill="outline" (click)="betoltes()" [disabled]="betolt"><ion-icon slot="start" name="refresh-outline"></ion-icon>{{ betolt ? 'Átnézés…' : 'Frissítés' }}</ion-button>
      </div>
      <ion-note color="danger" *ngIf="hiba">{{ hiba }}</ion-note>

      <div class="kb-muvelet" *ngIf="kijeloltIdk.length">
        <b>{{ kijeloltIdk.length }} kijelölve</b>
        <ion-input type="date" label="A bejelentés napja" labelPlacement="stacked" fill="outline" [(ngModel)]="bejelentesNapja"></ion-input>
        <ion-button color="success" (click)="jelol('bejelentve')" [disabled]="fut"><ion-icon slot="start" name="checkmark-done-outline"></ion-icon>Bejelentve</ion-button>
        <ion-input label="Miért nem kell? (kötelező)" labelPlacement="stacked" fill="outline" [(ngModel)]="ok" maxlength="500"></ion-input>
        <ion-button color="medium" (click)="jelol('nem_kell')" [disabled]="fut">Nem kell bejelenteni</ion-button>
        <ion-button fill="clear" color="medium" (click)="jelol('bejelentendo')" [disabled]="fut">Jelölés visszavonása</ion-button>
      </div>

      <div class="gorgo">
        <table class="kb-tabla" *ngIf="lathatok.length; else ures">
          <tr>
            <th><input type="checkbox" [checked]="mindKijelolve" (change)="mindetValt($any($event.target).checked)" title="Mind"></th>
            <th>Állapot</th><th>Személy</th><th>Esemény</th><th>Napja</th><th>Határidő</th><th>Jelölés</th>
          </tr>
          <ng-container *ngFor="let t of lathatok">
            <tr [class.halvany-sor]="!t.forras_megvan">
              <td><input type="checkbox" [(ngModel)]="kijelolt[t.id]"></td>
              <td>
                <ion-badge [color]="szin(t)">{{ t.allapot_nev }}</ion-badge>
                <div class="kicsi" *ngIf="hatraSzoveg(t)">{{ hatraSzoveg(t) }}</div>
              </td>
              <td>
                <b>{{ t.nev || t.szemely }}</b>
                <div class="kicsi">{{ t.tipus === 'alkalmazott' ? 'alkalmazott' : 'tanuló' }}{{ t.oktazon ? ' · ' + t.oktazon : '' }}</div>
                <div class="kicsi figy" *ngIf="t.kir_azonosito_nelkul">nincs érvényes oktatási azonosító – igénylés (14. §)</div>
              </td>
              <td>
                {{ t.esemeny_nev }}<span *ngIf="t.reszlet_nev"> – {{ t.reszlet_nev }}</span>
                <div class="kicsi">{{ t.leiras }}</div>
                <a class="kicsi link" (click)="reszletNyitva = reszletNyitva === t.id ? null : t.id">{{ reszletNyitva === t.id ? 'kevesebb' : 'részletek' }}</a>
              </td>
              <td class="nw">{{ t.datum | date:'yyyy.MM.dd.' }}</td>
              <td class="nw">{{ t.hatarido | date:'yyyy.MM.dd.' }}</td>
              <td>
                <ng-container *ngIf="t.allapot === 'bejelentve'">
                  {{ t.bejelentes_datuma | date:'yyyy.MM.dd.' }}<span class="figy" *ngIf="t.kesve"> (határidő után)</span>
                  <div class="kicsi">{{ t.bejelentette || '–' }}, {{ t.bejelentve }}</div>
                </ng-container>
                <ng-container *ngIf="t.allapot === 'nem_kell'">
                  <div class="kicsi">{{ t.megjegyzes }}</div>
                  <div class="kicsi">{{ t.bejelentette || '–' }}, {{ t.bejelentve }}</div>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="reszletNyitva === t.id" class="reszlet">
              <td></td>
              <td colspan="6">
                <div class="kicsi">Jogalap: {{ t.jogalap }}</div>
                <div class="kicsi">Rögzítve: {{ t.rogzitve }}{{ t.rogzitette ? ' (' + t.rogzitette + ')' : '' }} · forrás: {{ t.forras === 'jogviszony' ? 'be-/kiiratkozás' : t.forras === 'kilepes' ? 'kiléptetés' : 'a jogviszonyok átnézése' }}</div>
                <div class="kicsi" *ngFor="let s of elozmenySorok(t)">{{ s }}</div>
              </td>
            </tr>
          </ng-container>
        </table>
        <ng-template #ures><p class="halvany" *ngIf="!betolt">Nincs ilyen tétel.</p></ng-template>
      </div>
      <p class="halvany" *ngIf="tol">A lista {{ tol | date:'yyyy.MM.dd.' }}-tól (a tanév kezdete) mutatja az eseményeket, és minden korábbi, még nyitott tételt.</p>
    </ion-card-content>
  </ion-card>
</div>
